import { GET_BALANCE } from "../../actions/type";

export default function accountDetail(state = [], action) {
    switch (action.type) {
        case GET_BALANCE:
            return action.payload;
        default:
            return state
    }
}